import React from 'react';
import PropTypes from 'prop-types';
import UserDropdown from '@pedidosya/web-fenix/specifics/UserDropDown';
import TopAppBar from '@pedidosya/web-fenix/system/TopAppBar';
import { getLogo } from '@pedidosya/web-fenix/utils/image';

function Header({ onGoBack, currentUser, ...props }) {
  return (
    <TopAppBar
      asset={getLogo('Logo')}
      left={onGoBack ? 'icon' : 'empty'}
      middle="asset"
      onGoBack={onGoBack}
      {...props}
    >
      <TopAppBar.Right>
        <UserDropdown user={currentUser} />
      </TopAppBar.Right>
    </TopAppBar>
  );
}

Header.propTypes = {
  onGoBack: PropTypes.func,
  currentUser: PropTypes.object,
};

export default Header;
